import { SelectOption } from 'ui';

export const findDefaultValue = <T>(array: SelectOption<T>[], defaultValue: any) => {
  return array.find(({ value }) => value === defaultValue);
};
